import "./Header.css";
import logo from "../../assets/images/logo.png";
import english from "../../assets/images/english.png";
import menu from "../../assets/svg/menu.svg";
import { useDialog } from "../DialogProvider/DialogProvider";
import { Offcanvas } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
function Header() {
  const { openDialog } = useDialog();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="Header">
        <img src={logo} alt="logo" className="logo" />
        <div className="menu-content d-lg-flex d-none">
          <div className="select-container">
            {/* <label>
              <img src={english} alt="english" />
              <span>English</span>
              <i className="down"></i>
            </label> */}
          </div>
          <div className="menu-btns">
            <button
              className="menu-btn-theme"
              onClick={() => {
                handleClose();
                window.open("https://portal.brainyclock.com", "_blank");
              }}
            >
              Log in
            </button>
            <button className="menu-btn" onClick={() => navigate("/signup")}>
              Sign Up
            </button>
          </div>
        </div>
        <img
          src={menu}
          className="d-lg-none d-block"
          alt="menu"
          onClick={handleShow}
        />
      </div>
      <Offcanvas className="header-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={logo} alt="logo" className="logo" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="menu-content d-flex flex-column gap-24">
            <div className="select-container" style={{ width: 'fit-content' }}>
              <label>
                <img src={english} alt="english" />
                <span>English</span>
                <i className="down"></i>
              </label>
            </div>
            <div className="menu-btns d-flex gap-12">
              <button
                className="menu-btn-theme"
                onClick={() => {
                  handleClose();
                  window.open("https://portal.brainyclock.com", "_blank");
                }}
              >
                Log in
              </button>
              <button className="menu-btn" onClick={() => { handleClose(); navigate("/signup") }}>
                Sign Up
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Header;
